// extracted by mini-css-extract-plugin
export default {"bg-image":"Modal_bg-image__9Ryy4"};